import { render, staticRenderFns } from "./modify-license-modal.vue?vue&type=template&id=7565c470"
import script from "./modify-license-modal.vue?vue&type=script&lang=js"
export * from "./modify-license-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports